import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=6a1343c6&scoped=true&"
import script from "./PasswordChange.vue?vue&type=script&lang=ts&"
export * from "./PasswordChange.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&id=6a1343c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1343c6",
  null
  
)

export default component.exports